/* eslint-disable eqeqeq */
import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { FunctionUtil } from "../../../../util/FunctionUtil";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { ModalContext } from "../../../../provider/ModalProvider";

class CadenaAguaPage extends BasePage {
  static contextType = ModalContext;
  
  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1"
    }
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    })
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () => pageApi.getComponent('gridDetalleMuestreo');
    const getgrid_resultados_parametros = () => pageApi.getComponent('gridResultadosParametros');
    const { TabPane } = Tabs;

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getgrid_detalle_muestreo().saveItemEditing();
      const arrMuestreo = getgrid_detalle_muestreo().getData();

      setTimeout(() => {
        arrMuestreo.forEach(el => {
          if (data.key == el.key) {
            getgrid_detalle_muestreo().updateItem({
              ...el,
              id_estacion: data.id_estacion,
              estaciondes: data.estaciondes,
              descripcion: data.descripcion,
              georeferencia: `E: ${data?.COORDF || "0"}, - N:  ${data?.COORDN || "0"}`,
              COORDF: data.COORDF,
              COORDN: data.COORDN,
            })
          } else {
            getgrid_detalle_muestreo().updateItem(el)
          }
        });
      }, 0)
    }

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz: getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
          id_empresa: getgrid_detalle_muestreo()?.itemEditing.id_empresa,
          id_estacion: id_estacion
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: 'white',
        component: esNuevo ? <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} /> : <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
      });
    };

    const gridDetalleMuestreo = (pageApi) => ({
      layout: "vertical",
      title: "Detalles de muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_muestreo",
      load: {
        search: true,
        queryId: 890,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
          };
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 895,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: () => {
          getgrid_resultados_parametros().load();
        }
      },
      fields: [
        { name: "muestra", label: "Codigo M." },
        { name: "matriz", label: "Matriz" },
        {
          type: 'select', name: 'id_estacion', labelName: 'estaciondes', label: 'Estación', column: 3, load: {
            queryId: 846,
            params: () => { return { id_empresa: getgrid_detalle_muestreo()?.itemEditing?.id_empresa, id_tipo_matriz: getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz } },
          }, search: true, editable: true,

          onChange: async (value, values, formApi) => {
            if (value == 0) {
              ConfigEstacionModal(formApi.getData(), true)
              formApi.setFieldData('id_estacion', null);
              formApi.setFieldData('descripcion', null);
              formApi.setFieldData('georeferencia', null);
            } else if (value == -1) {
              const id_estacion = getgrid_detalle_muestreo()?.itemEditing.id_estacion
              const estaciondes = getgrid_detalle_muestreo()?.itemEditing.estaciondes
              
              if (!id_estacion) {
                formApi.setFieldData('id_estacion', null);
                formApi.setFieldData('estaciondes', null);
                formApi.setFieldData('descripcion', null);
                formApi.setFieldData('georeferencia', null);
                return MessageUtil(
                  "warning",
                  "Advertencia",
                  "Debe seleccionar primero una estaciòn para poder editar."
                );
              }

              fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes })
              ConfigEstacionModal({ ...formApi.getData(), id_estacion, estaciondes }, false, id_estacion)
              formApi.setFieldData('id_estacion', id_estacion);
              formApi.setFieldData('estaciondes', estaciondes);
            } else {
              const id_estacion = value;
              let label = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.label;
              let descripcion = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.descripcion;

              const reqParams = LoadUtil.getReqParams({
                queryId: 138,
                params: {
                  ID_ESTACION: id_estacion
                },
              });

              const data = await RequestUtil.postData(EnvConstants.GET_URL_READ(), reqParams)
                .then((resp) => resp.dataObject)
                .catch(() => []);

              formApi.setFieldData('georeferencia', `E: ${data?.COORDF || "0"}, - N:  ${data?.COORDN || "0"}`);
              formApi.setFieldData('id_estacion', value);
              formApi.setFieldData('estacionDes', label || formApi.values.label);
              formApi.setFieldData('descripcion', descripcion || formApi.values.descripcion);

              if (formApi.values.id_estacion !== value) {
                fnUpdateItem({
                  ...formApi.getData(),
                  id_estacion,
                  estaciondes: label,
                  descripcion,
                  georeferencia: `E: ${data?.COORDF || "0"}, - N:  ${data?.COORDN || "0"}`,
                  COORDF: data?.COORDF,
                  COORDN: data?.COORDN,
                })
              }
            }
          }
        },
        { name: "georeferencia", label: "Georeferencia", readOnly: true },
        { name: "fecha_prevista_muestreo", label: "Fecha Muestreo", editable: true, type: 'date', format: 'DD/MM/YYYY', inputFormat: DATE_FORMAT.YYYYMMDD, },
        { name: "hora_inicio_muestreo", label: "Hora Muestreo", editable: true, type: 'date', format: DATE_FORMAT.HHmm, inputFormat: DATE_FORMAT.HHmm },
        { name: "fecha_recoleccion", label: "F. Recolección", editable: true, type: 'date', format: 'DD/MM/YYYY', inputFormat: DATE_FORMAT.YYYYMMDD },
        { name: "hora_recoleccion", label: "H. Recolección", editable: true, type: 'date', format: DATE_FORMAT.HHmm, inputFormat: DATE_FORMAT.HHmm },
        { name: "observacion", label: "Observaciones Relevantes", editable: true },
        { name: "cant_envases", label: "Cantidad", editable: true },
        {
          type: 'select', name: 'es_realizado', labelName: 'realizado', label: 'Estado', load: {
            dataList: [
              { label: 'REALIZADO', value: 'REALIZADO' },
              { label: 'NO REALIZADO', value: 'NO REALIZADO' },
            ]
          }, editable: true
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridResultadosParametros = (pageApi) => ({
      title: "Resultados de Parámetros",
      showIndex: true,
      autoLoad: true,
      rowId: "id_insitu",
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 891,
        params: () => {
          return {
            id_cadena: pageApi.getParamId(),
          };
        },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp, _, formApi, val) => {
          const data = resp.dataList?.filter(el => el.resultado && !el.incertidumbre);

          data.forEach(el => {
            if (FunctionUtil.esValidoNumero(el.resultado)) {
              let variable_incertidumbre = JSON.parse(el.variable_incertidumbre || '[]');
              let resultado = el.resultado.replace(',', '.');

              if (variable_incertidumbre[0]?.flg_asociado) {
                let ejecutar_operacion = "";
                let efectuar_operaciones_ma = (op) => {
                  if (op.tipo == "Fórmula" && op.tipo_variable == "Simple") {
                    let valor = 0;
                    variable_incertidumbre.forEach((x) => {
                      if (x.id_variable_incertidumbre == op.operacion) {
                        valor = x.valor;
                      }
                    });
                    ejecutar_operacion += valor;
                  }
                  else if (op.tipo == "Fórmula" && op.tipo_variable == "Calculado") {
                    op.operacion_interna.forEach((on1) => {
                      efectuar_operaciones_ma(on1);
                    });
                  }
                  else if (op.tipo == "Sistema" && op.operacion == "Resultado") {
                    ejecutar_operacion += " " + resultado;
                  }
                  else if (op.tipo == "Operador" && op.operacion == "|x|") { //tipo = Operador Valor Absoluto
                    ejecutar_operacion += " Math.abs";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "log") { //tipo = Operador Logaritmo
                    ejecutar_operacion += " Math.log";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "x^") { //tipo = Operador Potencia
                    ejecutar_operacion += " Math.pow";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "√x") { //tipo = Operador Raiz Cuadrada
                    ejecutar_operacion += " Math.sqrt";
                  }
                  else { //tipo = Valor, Operador
                    ejecutar_operacion += " " + op.operacion;
                  }
                }
                variable_incertidumbre.forEach((v) => {
                  if (v.flg_asociado) {
                    ejecutar_operacion = "";
                    v.operaciones.forEach((op) => {
                      efectuar_operaciones_ma(op);
                    });
                    if (v.tipo_variable == "Calculado") {
                      v.valor = FunctionUtil.ejecutarFunction(ejecutar_operacion);
                    }
                    // console.log("Operacion a Ejecutar : ", v.nombre);
                    // console.log(ejecutar_operacion);
                    // console.log("Resultado: ", resultado);
                    // console.log("Incertidumbre: ", isNaN(v.valor) ? 0 : v.valor);
                    // console.log("Incertidumbre Redondeada: ", isNaN(parseFloat(v.valor).toFixed(v.cantidad_decimales)) ? 0 : parseFloat(v.valor).toFixed(v.cantidad_decimales));
                    // console.log("id_rel_metodo_parametro: ", v.id_rel_metodo_parametro);
                    // console.log("cantidad_decimales: ", v.cantidad_decimales);
                    // console.log("==================================================================================");
                    el.resultado = resultado;
                    el.incertidumbre = parseFloat(v.valor).toFixed(v.cantidad_decimales);
                    getgrid_resultados_parametros().refresh();
                  }
                });
              }
            }
            else {
              el.incertidumbre = "";
            }
          })

          const items = getgrid_resultados_parametros().getData();

          data.forEach(el => {
            const item = items.find(it => it.id_insitu === el.id_insitu)

            getgrid_resultados_parametros().updateItem({
              ...item,
              ...el
            });
            getgrid_resultados_parametros().saveItemEditing()
          })
        }
      },
      save: {
        queryId: 892,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      dataOptions: {
        out: { includeLabel: true },
      },
      fields: [
        { name: "codigo_muestra", label: "Código M." },
        { name: "matriz", label: "Matriz" },
        { name: "estacion", label: "Estación" },
        { name: "parametro", label: "Parámetro" },
        {
          name: "resultado", label: "Resultados", editable: true, onChange: (value, values, formApi) => {
            if (FunctionUtil.esValidoNumero(values.resultado)) {
              let variable_incertidumbre = JSON.parse(getgrid_resultados_parametros()?.itemEditing?.variable_incertidumbre || '[]');
              let resultado = values.resultado.replace(',', '.');

              if (getgrid_resultados_parametros().itemEditing.id_insitu == formApi.values.id_insitu && variable_incertidumbre[0]?.flg_asociado) {
                let ejecutar_operacion = "";
                let efectuar_operaciones_ma = (op) => {
                  if (op.tipo == "Fórmula" && op.tipo_variable == "Simple") {
                    let valor = 0;
                    variable_incertidumbre.forEach((x) => {
                      if (x.id_variable_incertidumbre == op.operacion) {
                        valor = x.valor;
                      }
                    });
                    ejecutar_operacion += valor;
                  }
                  else if (op.tipo == "Fórmula" && op.tipo_variable == "Calculado") {
                    op.operacion_interna.forEach((on1) => {
                      efectuar_operaciones_ma(on1);
                    });
                  }
                  else if (op.tipo == "Sistema" && op.operacion == "Resultado") {
                    ejecutar_operacion += " " + resultado;
                  }
                  else if (op.tipo == "Operador" && op.operacion == "|x|") { //tipo = Operador Valor Absoluto
                    ejecutar_operacion += " Math.abs";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "log") { //tipo = Operador Logaritmo
                    ejecutar_operacion += " Math.log";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "x^") { //tipo = Operador Potencia
                    ejecutar_operacion += " Math.pow";
                  }
                  else if (op.tipo == "Operador" && op.operacion == "√x") { //tipo = Operador Raiz Cuadrada
                    ejecutar_operacion += " Math.sqrt";
                  }
                  else { //tipo = Valor, Operador
                    ejecutar_operacion += " " + op.operacion;
                  }
                }
                variable_incertidumbre.forEach((v) => {
                  if (v.flg_asociado) {
                    ejecutar_operacion = "";
                    v.operaciones.forEach((op) => {
                      efectuar_operaciones_ma(op);
                    });
                    if (v.tipo_variable == "Calculado") {
                      v.valor = FunctionUtil.ejecutarFunction(ejecutar_operacion);
                    }
                    // console.log("Operacion a Ejecutar : ", v.nombre);
                    // console.log(ejecutar_operacion);
                    // console.log("Resultado: ", resultado);
                    // console.log("Incertidumbre: ", isNaN(v.valor) ? 0 : v.valor);
                    // console.log("Incertidumbre Redondeada: ", isNaN(parseFloat(v.valor).toFixed(v.cantidad_decimales)) ? 0 : parseFloat(v.valor).toFixed(v.cantidad_decimales));
                    // console.log("id_rel_metodo_parametro: ", v.id_rel_metodo_parametro);
                    // console.log("cantidad_decimales: ", v.cantidad_decimales);
                    // console.log("==================================================================================");
                    formApi?.setFieldData("resultado", resultado);
                    formApi?.setFieldData("incertidumbre", parseFloat(v.valor).toFixed(v.cantidad_decimales));
                    getgrid_resultados_parametros().refresh();
                  }
                });
              }
            }
            else {
              formApi?.setFieldData("incertidumbre", "");
            }
          }
        },
        { name: "incertidumbre", label: "Incertidumbre", editable: true },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          labelName: "unidad_medida",
          column: 4,
          search: true,
          editable: true,
          load: {
            queryId: 583,
            params: () => {
              return {
                id_metodo: getgrid_resultados_parametros()?.itemEditing?.id_metodo || 0,
              };
            },
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: 'grid'
      },
      {
        name: "gridResultadosParametros",
        config: gridResultadosParametros(pageApi),
        type: 'grid'
      },
    ];

    return (
      <StickyContainer>
        <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection api={pageApi} name={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Datos del Servicio" key="2" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DatosServisiosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Procedencia de la muestra" key="3" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <ProcedenciaMuestraModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Detalle del muestreo" key="4" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DetalleMuestreoModal api={pageApi} data={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} gridsConfig={gridsConfigDetalleMuestreo} />
          </TabPane>

          <TabPane tab="Equipos Utilizados" key="5" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <EquiposUtilizadosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Otros Datos" key="6" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <OtrosDatosModal api={pageApi} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaAguaPage);